export default __webpack_public_path__ + "static/media/young-family-moving-into-their-new-house.98b99f2a.jpg";